import {Component} from '@angular/core';

@Component({
    selector: 'text-link',
    templateUrl: './link.component.html'
})
export class LinkComponent {

}
